import isEmpty from '../helpers/isEmpty'
//------------------
// get array object
//------------------
export default function getArrayObject(character, change) {
  //----------
  // declares
  //----------
  let change_object = null
  //-----------------
  // defensive check
  //-----------------
  if (isEmpty(character) || isEmpty(change)) {
    return { object: null, index: -1 }
  }
  //=======================================================================================================
  // A. EXISTING OBJECT: find object by id where provided (ok for all changes types for existing objects)
  // NB: for new runes (ADD) id will be a temp id used for tracking only cos of legitimate duplicates
  //-------------------------------------------------------------------------------------------------------
  if (change.id) {
    console.log('A. FINDING OBJECT BY ID = ' + change.id)
    console.log('character[`${change.type}`] = ', character[`${change.type}`])
    change_object = character[`${change.type}`].find((o) => o.id === change.id)
  } else {
    //==========================================================
    // B. NEW OBJECT: check for multiple objects with same name (e.g. runes)
    //----------------------------------------------------------
    const obj_name_cnt = character[`${change.type}`].filter((o) => o.name === change.name).length
    //------------------------------------------------
    // multiple objects - use idx for object matching
    //------------------------------------------------
    if (obj_name_cnt > 1) {
      console.warn('multiple object with name found = ' + change.name + ' / type = ' + change.type)
      console.log('B. FINDING OBJECT BY IDX = ' + change.idx)
      change_object = character[`${change.type}`][change.idx]
      //----------------------------------------------
      // single object - use name for object matching
      //----------------------------------------------
    } else {
      console.log('single object with name found = ' + change.name + ' / type = ' + change.type)
      console.log('C. FINDING OBJECT BY NAME = ' + change.name)
      change_object = character[`${change.type}`].find((o) => o.name === change.name)
    }
  }
  return change_object
}
